import { render, staticRenderFns } from "./AssessmentsHeader.vue?vue&type=template&id=7c46dbc8&"
import script from "./AssessmentsHeader.vue?vue&type=script&lang=js&"
export * from "./AssessmentsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports